import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { landingPageService, type FaqItem } from "../services/landingPageService";

interface LandingFaqState {
  data: FaqItem[];
  loading: boolean;
  error: string | null;
}

const initialState: LandingFaqState = {
  data: [],
  loading: false,
  error: null,
};

export const fetchLandingFaqs = createAsyncThunk(
  "landingFaq/fetch",
  async (_, { rejectWithValue }) => {
    try {
      return await landingPageService.getFaqs();
    } catch (err: any) {
      return rejectWithValue(
        err?.response?.data?.message || "Failed to fetch FAQ section"
      );
    }
  }
);

const landingFaqSlice = createSlice({
  name: "landingFaq",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchLandingFaqs.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchLandingFaqs.fulfilled, (state, action: PayloadAction<FaqItem[]>) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchLandingFaqs.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export default landingFaqSlice.reducer;